<section class="w-100 mw-700px rounded-3 px-8 px-lg-10" [formGroup]="form">
  <div
    class="dialog-header justify-content-center pb-0 pt-8 px-0 pt-lg-10 border-0"
  >
    <div
      class="d-flex flex-column align-items-center justify-content-center gap-2 border-bottom border-gray-300 border-bottom-dashed pb-8 w-100"
    >
      <div
        class="w-70px h-70px d-flex justify-content-center align-items-center rounded-circle bg-gray-100 border border-gray-200 mb-6"
      >
        <app-keenicon name="lock-3" class="fs-4x"></app-keenicon>
      </div>
      <h2 class="dialog-title text-gray-800 fw-semibold text-center mb-2">
        {{ "APP.RESET_PASSWORD" | translate }}
      </h2>
      <span class="text-gray-600 fs-4 text-center">
        {{ "APP.NEW_PASSWORD_REQUIRED" | translate }}
      </span>
    </div>
    <!-- <h3 class="dialog-title text-gray-800 fw-semibold">
      รีเซ็ตรหัสผ่าน {{ "APP.APP_NAME" | translate }}
    </h3>
    <button
      type="button"
      aria-label="Close"
      class="btn-close"
      (click)="onClose()"
    ></button> -->
  </div>
  <div class="dialog-content py-4 pt-6 pb-0 px-0">
    <div class="row g-6 py-4">
      <div class="col-12 mt-2">
        <app-input
          label="APP.NEW_PASSWORD"
          name="password"
          type="password"
          formControlName="password"
          placeholder="APP.NEW_PASSWORD"
          [labelMode]="LabelMode.DEFAULT"
          [required]="true"
          [error]="error?.password"
          autocomplete="new-password"
        ></app-input>
      </div>
      <div class="col-12 mt-3">
        <app-input
          label="APP.NEW_PASSWORD_CONFIRMATION"
          name="password_confirmation"
          formControlName="password_confirmation"
          type="password"
          placeholder="APP.NEW_PASSWORD_CONFIRMATION"
          [labelMode]="LabelMode.DEFAULT"
          [error]="error?.password_confirmation"
          autocomplete="new-password"
        ></app-input>
      </div>
    </div>
  </div>
  <div class="dialog-footer flex-center pt-4 pb-8 pb-lg-10 px-0 border-0">
    <button class="btn btn-primary w-100" data-testid="reset-password-submit" (click)="resetPassword()">
      {{ "APP.CHANGE_PASSWORD" | translate }}
    </button>
    <span
      class="mt-6 fs-6 text-underline cursor-pointer text-gray-600 text-hover-gray-800"
      (click)="onClose()"
      >{{ "COMPONENT.CANCEL" | translate }}</span
    >
  </div>
</section>
